import type { SARTResult, SceneFamily, RestorationDelta } from './types';

export function computeLumen(pre: SARTResult, post: SARTResult): RestorationDelta {
  const deltaCV = post.cvRT - pre.cvRT;
  const deltaComm = post.commissionErrors - pre.commissionErrors;
  const deltaMean = post.meanRT - pre.meanRT;

  // Positive lumen = improvement (lower variability + fewer lapses)
  // Tuned to feel rewarding on real data while staying honest
  const lumen = Math.max(0, Math.round(
    (-deltaCV * 480) - (deltaComm * 4.8) - (deltaMean * 0.03) + 18
  ));

  return {
    deltaCommission: deltaComm,
    deltaCV,
    deltaMeanRT: deltaMean,
    lumen,
  };
}

export function formatLumen(l: number): string {
  if (l >= 70) return `${l} (strong restoration)`;
  if (l >= 35) return `${l} (clear recovery)`;
  if (l >= 12) return `${l} (gentle return)`;
  return `${l} (subtle shift)`;
}

export function sceneLabel(s: SceneFamily): string {
  if (s === 'canopy') return 'Canopy';
  if (s === 'ripples') return 'Ripples';
  return 'Meadow';
}
